import type { CandidateDetails, CandidateType, CollegeDetails, OpenDetails, SchoolDetails } from '../types.ts';
import { collegeLevelLabel, districtLabel, qualificationLabel } from './enums.ts';
import { gradeLabel } from './candidateForm.ts';

/** One readable line describing where a candidate studies / works. */
export function describeDetails(type: CandidateType, d: CandidateDetails | null | undefined): string {
  if (!d) return '—';
  if (type === 'school') {
    const s = d as SchoolDetails;
    return [s.school_name, s.grade ? `इयत्ता ${gradeLabel(s.grade)}` : ''].filter(Boolean).join(' · ');
  }
  if (type === 'college') {
    const c = d as CollegeDetails;
    return [c.institution_name, c.degree, c.year_of_study ? `वर्ष ${c.year_of_study}` : '']
      .filter(Boolean)
      .join(' · ');
  }
  const o = d as OpenDetails;
  return [o.profession, o.qualification ? qualificationLabel(o.qualification) : ''].filter(Boolean).join(' · ');
}

/** Label/value rows for a details panel. */
export function detailRows(type: CandidateType, d: CandidateDetails): [string, string][] {
  if (type === 'school') {
    const s = d as SchoolDetails;
    return [
      ['इयत्ता', gradeLabel(s.grade)],
      ['शाळेचे नाव', s.school_name],
      ['शाळेचा पत्ता', s.school_address],
      ['शाळेचे नगर', s.school_locality],
      ['शाळेचे गाव / शहर', s.school_city],
      ['शाळेचा जिल्हा', districtLabel(s.school_district)],
      ['शाळेचा पिनकोड', s.school_pincode],
      ['शाळेचा दूरध्वनी', s.school_phone],
      ['शाळेचा ईमेल', s.school_email],
    ];
  }
  if (type === 'college') {
    const c = d as CollegeDetails;
    return [
      ['स्तर', collegeLevelLabel(c.level)],
      ['अभ्यासाचे वर्ष', String(c.year_of_study ?? '—')],
      ['पदवी / अभ्यासक्रम', c.degree],
      ['महाविद्यालय', c.institution_name],
    ];
  }
  const o = d as OpenDetails;
  return [
    ['शैक्षणिक पात्रता', qualificationLabel(o.qualification)],
    ['व्यवसाय', o.profession],
  ];
}
